module.exports = __webpack_public_path__ + "icons/original/large/large-c5.649a708fdfe3823d8ad66395bf760461.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c5.png
// module id = rxGk
// module chunks = app